import { provider } from "@grassrootly/api/providers";

export type ResetPasswordPayload = {
  access_token: string;
  refresh_token: string;
  password: string;
};

export const ResetPassword = async (params: ResetPasswordPayload): Promise<boolean> =>
  provider.Request<ResetPasswordPayload, boolean>("/auth/reset-password", params);
